import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';

interface LoginScreenProps {
  isDevelopmentMode?: boolean;
}

export default function LoginScreen({ isDevelopmentMode = false }: LoginScreenProps) {
  const { login } = useAuth();

  useEffect(() => {
    // Handle development mode first
    if (isDevelopmentMode) {
      const envToken = import.meta.env.VITE_JWT_TOKEN;
      if (envToken && envToken.length > 10) {
        login(envToken, {
          id: '123',
          name: 'Dev User',
          email: 'dev@exac.com',
          avatar: undefined,
        });
        return;
      }
    }

    // Redirect immediately to backend unified auth
    redirectToBackendAuth();
  }, [isDevelopmentMode, login]);

  const redirectToBackendAuth = () => {
    console.log('🚀 Redirecting to unified authentication...');

    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://chime-api-staging.braveforest-40c1a64b.eastus.azurecontainerapps.io';
    const state = btoa(JSON.stringify({
      timestamp: Date.now(),
      platform: 'web'
    }));

    const redirectUri = window.location.origin + '/auth/callback';

    // Redirect to backend unified auth page
    const backendAuthUrl = `${API_BASE_URL}/auth/unified/login` +
      '?redirect_uri=' + encodeURIComponent(redirectUri) +
      '&client_id=chime-web-app' +
      '&response_type=code' +
      '&scope=openid%20profile%20email' +
      '&state=' + encodeURIComponent(state) +
      '&platform=web' +
      '&_t=' + Date.now();

    console.log('🌐 Redirecting to backend login page');
    window.location.href = backendAuthUrl;
  };

  // Show minimal loading state while redirecting
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#008543] mx-auto"></div>
        <p className="text-gray-600 mt-4">Redirecting to login...</p>
      </div>
    </div>
  );
}
